import { useMutation } from "react-query"
import authService from "authService"
// helpers
import isUndefined from 'lodash/isUndefined'
import axiosRequest from "utils/axiosRequest"
// constant
const authApp = process.env.REACT_APP_AUTH_URL

type eventsType = "USER" | "ROLES" | "AIRFIND_USER" | "PAGE" | "TICKET"
type actionsType = "VIEW" | "CLICK" | "UPDATE" | "DELETE" | "LOG_IN" | "LOG_OUT"

interface loActionPayload {
  event: eventsType
  action: actionsType
  metadata: any
}
type logActionFn = (val: loActionPayload) => void

export const registerLog = async ({ event, action, metadata }: loActionPayload) => {
  const paginated = true
  const { data } = await axiosRequest({
    baseURL: authApp,
    url: `/event/register/${event}/${action}`,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${authService.state.authToken}`
    },
    data: {
      metadata: JSON.stringify(metadata)
    }
  })

  if (isUndefined(data)) throw new Error('')

  return data
}

const useLogAction = () => {
  const { mutate } = useMutation({
    mutationFn: registerLog,
    mutationKey: "LogActionOnApi"
  })

  const logAction: logActionFn = mutate
  const logPageView = (metadata) => mutate({ action: "VIEW", event: "PAGE", metadata })

  return {
    logAction,
    logPageView
  }
}

export default useLogAction